import React from 'react'

const ServiceDescription =  React.memo(({ ServiceDescriptiondata, setServiceDescriptionData }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setServiceDescriptionData({ ...ServiceDescriptiondata, [name]: value });
  };

  return (
    <div className='flex flex-col space-y-3 mx-10'>
       <div className="flex flex-col">
                <label htmlFor="addedBy" className="font-semibold text-[#667085]">
                    Service Description <span className="text-red-500">*</span>
                </label>
                <textarea
                    id="serviceDescription"
                    name="p_description"
                    value={ServiceDescriptiondata.p_description}
                    onChange={handleChange}
                    required
                    placeholder='Type Service Description'
                    className="mt-2 p-2 border border-gray-300 rounded-md h-[200px] outline-sky-300"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="addedBy" className="font-semibold text-[#667085]">
                  Service Variants <span className="text-red-500">*</span>
                </label>
                <textarea
                    id="serviceVariants"
                    name="p_varient"
                    value={ServiceDescriptiondata.p_varient}
                    onChange={handleChange}
                    required
                    placeholder='Type Service Variants'
                    className="mt-2 p-2 border border-gray-300 rounded-md h-[200px] outline-sky-300"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="addedBy" className="font-semibold text-[#667085]">
                    Service Certifications <span className="text-red-500">*</span>
                </label>
                <textarea
                    id="servicecertifications"
                    name="p_certification"
                    value={ServiceDescriptiondata.p_certification}
                    onChange={handleChange}
                    required
                    placeholder='Type Service Certifications'
                    className="mt-2 p-2 border border-gray-300 rounded-md h-[200px] outline-sky-300"
                />
            </div>
    </div>
  )
});

export default ServiceDescription
